import { createAction } from '@reduxjs/toolkit';
export const getImageList = createAction('images/getImageList');
export const getImageListResolved = createAction('images/getImageList/resolved');
export const getImageListRejected = createAction('images/getImageList/rejected');
